<template>
  <div class="pc_container app-main-content">
    <leftSlider :list="leftList" :check="1"></leftSlider>
    <div class="app-main-content-section bgfff c266">
      <div class="page_title">系统设置</div>
      <div class="box1 box">
        <div class="c266 f20 bold mb32">设置小程序上自检问卷显示的时间</div>
        <div class="flex flex_items mb24">
          <div class="label-items">距离填报开始多长时间进行提前显示</div>
          <div>
            <el-input placeholder="请输入" v-model="advance_time" class="w400">
              <template slot="append">分钟</template>
            </el-input>
          </div>
        </div>
        <div class="flex flex_items mb24">
          <div class="label-items">距离填报截止多长时间进行倒计时提醒</div>
          <div>
            <el-input placeholder="请输入" v-model="up_time" class="w400">
              <template slot="append">分钟</template>
            </el-input>
          </div>
        </div>
        <div class="flex flex_items">
          <div class="label-items">超时未填报的问卷保留显示多长时间</div>
          <div>
            <el-input placeholder="请输入" v-model="exceed_time" class="w400">
              <template slot="append">分钟</template>
            </el-input>
          </div>
        </div>
      </div>

      <!-- <div class="box2 box">
        <div class="c266 f20 bold mb32">设置公众号里是否推送消息</div>
        <div class="flex flex_items mb24">
          <div class="label-items">问卷填报时间开始推送</div>
          <div>
            <el-radio-group v-model="status">
              <el-radio label="2">不推送</el-radio>
              <el-radio label="1">推送</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="flex flex_items mb24">
          <div class="label-items">问卷填报时间即将截止时推送</div>
          <div>
            <el-radio-group v-model="status">
              <el-radio label="2">不推送</el-radio>
              <el-radio label="1">推送</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="flex flex_items">
          <div class="label-items">问卷填报时间截止时推送</div>
          <div>
            <el-radio-group v-model="status">
              <el-radio label="2">不推送</el-radio>
              <el-radio label="1">推送</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div> -->
      <div class="box2 box" style="margin-bottom: 48px;">
        <div class="c266 f20 bold mb24">其他设置</div>
        <div class="flex flex_items mb24">
          <div class="label-items" style="width: 113px;">是否开启保密协议</div>
          <div>
            <el-radio-group v-model="secrecy_agreement">
              <el-radio label="1">开启</el-radio>
              <el-radio label="2">关闭</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="box2 box">
        <div class="flex flex_items">
          <div class="label-items" style="width: 113px;"></div>
          <div class="sub_btn page_main_bg cf" @click="areaSubmit">立即提交</div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import leftSlider from '@/components/leftSlider/leftSlider'
import leftList from './utils/list'
import { PUBLICURL } from '@/utils/index'
import { getRoleArr } from '@/utils/tool';
import { phoneCheck } from '@/utils/public'
import UploadFile from '@/components/uploadFile.vue';
import { exportUrl } from '@/utils/downloadUrl'
import bread from '@/utils/breadList'

export default {
  data() {
    return {
      PUBLICURL: PUBLICURL,
      check: 0,
      leftList: leftList,
      dialogVisible: false,
      keyword: '',
      role: getRoleArr,
      code: '',
      input2: '',
      password: '',
      account: '',
      handleId: '',
      drawSelect: [],
      options: [],//弹窗里面的岗位选择
      optionstaues: [],
      listOption: [],
      store: '',
      job: '',
      address: '',
      SlectRegion: '',



      advance_time: '',
      up_time: '',
      exceed_time: '',
      secrecy_agreement: '',

      status: ''




    };
  },
  components: { leftSlider, UploadFile },
  watch: {

  },
  methods: {
    areaSubmit() {
      this.api.postUrl('/api/manage/system/config', {
        advance_time: this.advance_time,
        up_time: this.up_time,
        exceed_time: this.exceed_time,
        secrecy_agreement: this.secrecy_agreement,
      }, { loading: true })
        .then((res) => {
          this.$message.success('操作成功')
          // this.advance_time = res.data.advance_time;
          // this.exceed_time = res.data.exceed_time;
          // this.secrecy_agreement = res.data.secrecy_agreement;
          // this.up_time = res.data.up_time;
        });

    },
    getInfo() {
      this.api.getUrl('/api/manage/system/config', {}, { loading: true })
        .then((res) => {
          this.advance_time = res.data.advance_time;
          this.exceed_time = res.data.exceed_time;
          this.secrecy_agreement = res.data.secrecy_agreement;
          this.up_time = res.data.up_time;
        });
    },



  },
  created() {
    this.getInfo()
    this.exportUrl = exportUrl(1)
    this.$store.dispatch('app/setBreadListMutations', bread(4, '', '系统设置'))
    this.leftList = leftList;

    // this.addNew()
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.w400 {
  width: 400px;
}

.label-items {
  text-align: right;
  margin-right: 12px;
  font-size: 14px;
}

.box1 .label-items {
  width: 240px;
}

.box2 .label-items {
  width: 182px;
}

.box {
  margin-bottom: 48px;
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>